import React from "react";
import Chart from "chart.js";
import { useGetInterviewTrendsQuery } from '../../redux/features/services/dashboard.service'

export default function CardLineChart() {

  const { data: interviewTrends = [], isLoading } = useGetInterviewTrendsQuery()



  const buildChart = () => {
    const _labels = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    const _created = [];
    const _technical = [];
    if(!isLoading){
      for(let key of _labels){
        let createdValue = interviewTrends["CREATED"] ? interviewTrends["CREATED"][key] : 0;
        _created.push(createdValue);
        let techniclValue = interviewTrends["TECHNICAL"] ? interviewTrends["TECHNICAL"][key] : 0;
        _technical.push(techniclValue);
      }
    }      
    var config = {
      type: "line",
      data: {
        labels: _labels,
        datasets: [
          {
            label: "Process Created.",
            backgroundColor: "#4c51bf",
            borderColor: "#4c51bf",
            data: _created,
            fill: false,
          },
          {
            label: "Technical Scheduled",
            fill: false,
            backgroundColor: "#fff",
            borderColor: "#fff",
            data: _technical,
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: false,
          text: "Interview Trends",
          fontColor: "white",
        },
        legend: {
          labels: {
            fontColor: "white",
          },
          align: "end",
          position: "bottom",
        },
        tooltips: {
          mode: "index",
          intersect: false,
        },
        hover: {
          mode: "nearest",
          intersect: true,
        },
        scales: {
          xAxes: [
            {
              ticks: {
                fontColor: "rgba(255,255,255,.7)",
              },
              display: true,
              scaleLabel: {
                display: false,
                labelString: "Month",
                fontColor: "white",
              },
              gridLines: {
                display: false,
                borderDash: [2],
                borderDashOffset: [2],
                color: "rgba(33, 37, 41, 0.3)",
                zeroLineColor: "rgba(0, 0, 0, 0)",
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                fontColor: "rgba(255,255,255,.7)",
              },
              display: true,
              scaleLabel: {
                display: false,
                labelString: "Value",
                fontColor: "white",
              },
              gridLines: {
                borderDash: [3],
                borderDashOffset: [3],
                drawBorder: false,
                color: "rgba(255, 255, 255, 0.15)",
                zeroLineColor: "rgba(33, 37, 41, 0)",
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
            },
          ],
        },
      },
    };
    var ctx = document.getElementById("line-chart").getContext("2d");
    window.myLine = new Chart(ctx, config);
  }

  React.useEffect(() => {
    buildChart();
  }, [isLoading]);

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-blueGray-700">
        <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full max-w-full flex-grow flex-1">
              <h6 className="uppercase text-blueGray-100 mb-1 text-xs font-semibold">
                Overview
              </h6>
              <h2 className="text-white text-xl font-semibold">Technical Interview Trends</h2>
            </div>
          </div>
        </div>
        <div className="p-4 flex-auto">
          {/* Chart */}
          <div className="relative h-350-px">
            <canvas id="line-chart"></canvas>
          </div>
        </div>
      </div>
    </>
  );
}
